import { render, staticRenderFns } from "./rewardsWithdraw.vue?vue&type=template&id=5b8145d4"
import script from "./rewardsWithdraw.vue?vue&type=script&lang=js"
export * from "./rewardsWithdraw.vue?vue&type=script&lang=js"
import style0 from "./rewardsWithdraw.vue?vue&type=style&index=0&id=5b8145d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports